import { HashRouter } from "react-router-dom";
import Routing from "./routes/Routing";
import "./css/style.css";
import { AxiosInterceptor } from "./config/axiosInstance";
import { AdminContextProvider, ChatProvider } from "./context/context";

function App() {
  return (
    <>
      <AdminContextProvider>
        <HashRouter>
          <ChatProvider>
            <AxiosInterceptor>
              <Routing />
            </AxiosInterceptor>
          </ChatProvider>
        </HashRouter>
      </AdminContextProvider>
    </>
  );
}

export default App;
